/* import __COLOCATED_TEMPLATE__ from './header-link.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();